import { curry } from './curry'

export const pluck = curry((prop, obj) => obj[prop])
